import styles from "./lightbox-prompt.module.scss";
import { MouseEvent, PropsWithChildren, ReactNode } from "react";
import clsx from "clsx";

interface propsType {
  title: ReactNode;
  frameClassName?: string;
  onBackdropClick?(): void;
}
export default function LightboxPrompt(props: PropsWithChildren<propsType>) {
  function handleBackdropClick() {
    if (props.onBackdropClick) {
      props.onBackdropClick();
    }
  }
  function handleFrameClick(e: MouseEvent<HTMLElement>) {
    e.stopPropagation();
  }

  return (
    <div className={styles.Overlay} onClick={handleBackdropClick}>
      <article
        className={clsx(props.frameClassName, styles.Frame)}
        onClick={handleFrameClick}
      >
        <h1 className={styles.Title}>{props.title}</h1>
        {props.children}
      </article>
    </div>
  );
}
